let BranchSDK: any = undefined;

const DEEP_LINK_COLLECTION: any = {};

export function getBranchSDK() {
  const HasBranchSDK = typeof BranchSDK;

  switch (HasBranchSDK) {
    case 'undefined':
      BranchSDK = import('branch-sdk').then(() => {
        BranchSDK = window.branch;
        window.branch.init('key_live_dduwTImBLx743248uGpEWlefBEblKrhu');
        return window.branch;
      });
      return BranchSDK;
    default:
      return Promise.resolve(BranchSDK);
  }
}

function setDeepLink(id: string, link: any) {
  DEEP_LINK_COLLECTION[id] = link;
}

function getDeepLink(id: string) {
  return DEEP_LINK_COLLECTION[id];
}

export const requestDeepLink = (id: string, data: any): Promise<string> =>
  new Promise((resolve, reject) =>
    getBranchSDK().then(() => getBranchLink(id, data, resolve, reject))
  );

export const getBranchLink = (id: string, data: any, resolve: any, reject: any) => {
  const deepLinkData = getDeepLink(id);
  if (typeof deepLinkData === 'undefined') {
    return window.branch.link(data, (error, linkData) => {
      if (error) {
        reject(error);
      } else {
        setDeepLink(id, linkData);
        return resolve(linkData);
      }
    });
  }

  return resolve(deepLinkData);
};
